import MediaComponentFactory from 'app/components/mediaModule/content/MediaComponentFactory';
import React from 'react';
import SwipeableViewsStepper from 'app/components/swipeableViews/SwipeableViewsStepper';
import { View, Wrapper } from 'app/components/mediaModule/content/contentStyles';
import createRenderedViewsFromArray from 'app/components/swipeableViews/createRenderedViewsFromArray';
import MediaModulePlaceholder from 'app/components/mediaModule/MediaModulePlaceholder';
import { useLocation } from 'react-router';
import { DistrictMainPageModuleType, useDistrictMainPageTracking } from 'app/components/district/news/DistrictMainPageTracking';
export default function MediaModuleContent(_ref) {
  let {
    data,
    districtName
  } = _ref;
  const location = useLocation();
  const createFiller = index => /*#__PURE__*/React.createElement(Wrapper, {
    key: "media-filler-".concat(index),
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "createFiller",
    "data-sentry-source-file": "MediaModuleContent.tsx"
  });
  const {
    trackClickedItemPage,
    updateTrackingData
  } = useDistrictMainPageTracking();
  const handleOnClick = pageIndex => {
    trackClickedItemPage(DistrictMainPageModuleType.MEDIA, pageIndex);
  };
  const views = createRenderedViewsFromArray(data, MediaComponentFactory.create, createFiller);
  if (!views.length) {
    return /*#__PURE__*/React.createElement(MediaModulePlaceholder, {
      districtName: districtName,
      pathname: location.pathname
    });
  }
  return /*#__PURE__*/React.createElement(SwipeableViewsStepper, {
    callback: data => updateTrackingData(DistrictMainPageModuleType.MEDIA, data),
    views: views,
    viewRender: _ref2 => {
      let {
        index
      } = _ref2;
      return /*#__PURE__*/React.createElement(View, {
        onClick: () => handleOnClick(index),
        key: "media-view-".concat(index)
      }, views[index]);
    },
    "data-sentry-element": "SwipeableViewsStepper",
    "data-sentry-component": "MediaModuleContent",
    "data-sentry-source-file": "MediaModuleContent.tsx"
  });
}